import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PlatformLocation} from '@angular/common';
import { CommonService } from "../common.service";

@Component({
  selector: 'app-ai-coach',
  templateUrl: './app-ai-coach.component.html',
  styleUrls: ['./app-ai-coach.component.css']
})
export class AppAiCoachComponent implements OnInit, AfterViewInit {

  assetsRoute: string = "../../assets";

  constructor(private route: ActivatedRoute,
              private router: Router,
              private commonService: CommonService,
              private platformLocation: PlatformLocation) {}

  ngOnInit() {

  }

  ngAfterViewInit(){
    this.commonService.initPage({'backgroundColor': 'rgba(255,255,255,1)'});
  }

  goLearningMap():void{
    if(localStorage.getItem('onlyCamp')){
      this.router.navigate(['learning-camp',localStorage.getItem('skuId'),localStorage.getItem('campId'),-1]);
    }else{
      this.router.navigate(['learning-map']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app-ai-coach/app-ai-coach.component.ts